import PlusSquared from './PlusSquared'

export default PlusSquared
// eslint-disable-next-line import/export
export * from './PlusSquared'
